
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexqNndykr5I3J2YBdLD7sX7lV2qenAN6atCrdTpio5FQAMeta } from "/home/galadriel/az-agent/_work/1/s/pages/index.vue?macro=true";
import { default as perfilHz7MdddUSjLLxk7LAHdqJfEErYah_qz5lDea9z_45CmCQMeta } from "/home/galadriel/az-agent/_work/1/s/pages/perfil.vue?macro=true";
import { default as guardados5YCLHplmpWk_45skbuOMJQn7YVwzkIH0ZMfWvNNaXyhR4Meta } from "/home/galadriel/az-agent/_work/1/s/pages/guardados.vue?macro=true";
import { default as mi_45asesordxHzdyp0FZOKfRhgDi7Ey16ohRM5PHu_45NWyGvSOcuwQMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mi-asesor.vue?macro=true";
import { default as mi_45startupGORsrLfw2uNa7D5O_45JT8rFX9FON2c1g1MxoIjj12ZxwMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mi-startup.vue?macro=true";
import { default as privacidadlXJtpCuI5VY0vLZ5QFzCWSmJORYxhSHGykhJZGGDoMEMeta } from "/home/galadriel/az-agent/_work/1/s/pages/privacidad.vue?macro=true";
import { default as aviso_45legal2ErD011d_D7Di0J1LP98EmGb51Zu8k44_E5aaEBdMScMeta } from "/home/galadriel/az-agent/_work/1/s/pages/aviso-legal.vue?macro=true";
import { default as mis_45eventosGFKTZ8IysmwgvUpxihxmnUH2jKhkj_45DEbAQoRucUsysMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mis-eventos.vue?macro=true";
import { default as _91slug_93cDwLgn_45JCStio9y1zAQg5DB3WS69ZN5dqVqE3jA2tSsMeta } from "/home/galadriel/az-agent/_work/1/s/pages/autor/[slug].vue?macro=true";
import { default as accesibilidadG_45afe_45bPIZgQuovxT18iP1_45y_59Ptnu5dsuQxXHgCkoMeta } from "/home/galadriel/az-agent/_work/1/s/pages/accesibilidad.vue?macro=true";
import { default as _91slug_93zPhop_7F4Esn5C2qPAwRUvxZwnnTWzoOGHag_UtSB7AMeta } from "/home/galadriel/az-agent/_work/1/s/pages/invita/[slug].vue?macro=true";
import { default as publicacionescTta1Ij4yYjSPIz1RDhfTz_45H2n2d8yW3X7yo5w6ByaAMeta } from "/home/galadriel/az-agent/_work/1/s/pages/publicaciones.vue?macro=true";
import { default as quienes_45somosl91lNxc8nAMvtTKJIHtMHd8cJP8JquStfh3nFokuqFoMeta } from "/home/galadriel/az-agent/_work/1/s/pages/quienes-somos.vue?macro=true";
import { default as indexwixN9xBNCk1j9ne19yNBR9sKByvawmzxO64NcJd7IdQMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mercados/index.vue?macro=true";
import { default as indexEXPrDZ079_45SUbBhkbEE32O3xWjmiJ6sT0D5a2dG4qp8Meta } from "/home/galadriel/az-agent/_work/1/s/pages/registro/index.vue?macro=true";
import { default as indexL2q3ejcBBRZZlcjrjqg3uVKp96TCZttT9yDvnUL68HIMeta } from "/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/index.vue?macro=true";
import { default as indexKI3hQyay_hxp2H6Vj8Hgmln5p7hH96Zvg4kt4zf7Xz8Meta } from "/home/galadriel/az-agent/_work/1/s/pages/tierratv/index.vue?macro=true";
import { default as indexsUAqB0oGztnZRXtv8Kw2qWvFBAqhqKqsD_Y1f_45B87eIMeta } from "/home/galadriel/az-agent/_work/1/s/pages/comunidad/index.vue?macro=true";
import { default as _91slug_93_i2cL7rjy6ewhS7KwRJoFcGbCGaWf6IIYgPm9GqsDmYMeta } from "/home/galadriel/az-agent/_work/1/s/pages/encuesta/[slug].vue?macro=true";
import { default as index_LcK0aLGx7J4swNH_45CcJEs96A5_hfp7_45mP7u6uyYz5sMeta } from "/home/galadriel/az-agent/_work/1/s/pages/formacion/index.vue?macro=true";
import { default as _91slug_93ko3nrOTua9kNvqOo4s9d510lZBjHbqBifj_xz3__tmwMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mercados/[slug].vue?macro=true";
import { default as _91slug_93iyyW28niYgfsCODxT31i1Vn7s2_JABx2qKmzAHgMx0sMeta } from "/home/galadriel/az-agent/_work/1/s/pages/proyecto/[slug].vue?macro=true";
import { default as indexgNjVU_YR_5HRM9y2_45TiNDiee5PpVA928hVgzT2EoEggMeta } from "/home/galadriel/az-agent/_work/1/s/pages/actualidad/index.vue?macro=true";
import { default as _91slug_93E1f1Z_453vKD2tWltB_X6pgGtIFq_45pe9OtKIJmLNFmjSEMeta } from "/home/galadriel/az-agent/_work/1/s/pages/formacion/[slug].vue?macro=true";
import { default as index5FsYmSNQn0Z8XPELyi12ywu6H057rWQQrqrh1SF6M1oMeta } from "/home/galadriel/az-agent/_work/1/s/pages/innovacion/index.vue?macro=true";
import { default as _91slug_93hS0EvIMpuSrLVFXtSZHXO86qn903U9CUhWz1mpxKte0Meta } from "/home/galadriel/az-agent/_work/1/s/pages/actualidad/[slug].vue?macro=true";
import { default as _91slug_93xee99MgMi5E1R8wgNzWOsilRrt7G4_45HPsbpquJVustoMeta } from "/home/galadriel/az-agent/_work/1/s/pages/innovacion/[slug].vue?macro=true";
import { default as actualizar_45usuarioe2nzt_45rkwgMTX_SrnrMjquZ_Ofa37pWqvCowUX8yriQMeta } from "/home/galadriel/az-agent/_work/1/s/pages/actualizar-usuario.vue?macro=true";
import { default as condiciones_45de_45usoK_45JauuRxgU1CIS7NP2wye0_45FnEzZYIkHY6E__45gGqfekMeta } from "/home/galadriel/az-agent/_work/1/s/pages/condiciones-de-uso.vue?macro=true";
import { default as _91slug_93JrYrTbX2lbMGWBGXppdsbyOuvKkiaAc8c3QDEyPchdEMeta } from "/home/galadriel/az-agent/_work/1/s/pages/herramientas/[slug].vue?macro=true";
import { default as politica_45de_45cookiesL865ZRHVN9_GQRCp6pbGN3bIg5CwfHYvt1mvLKsD044Meta } from "/home/galadriel/az-agent/_work/1/s/pages/politica-de-cookies.vue?macro=true";
import { default as resultados_45busquedayjUBmiRj09WhnxHOSQRuq_450xsicPq1YGHpmRpMdSNQ8Meta } from "/home/galadriel/az-agent/_work/1/s/pages/resultados-busqueda.vue?macro=true";
import { default as _91id_93BZYS3e3ZOxWY_4504EMoI6J691T_4523VuoY5d5FA4excT4Meta } from "/home/galadriel/az-agent/_work/1/s/pages/tierratv/video/[id].vue?macro=true";
import { default as verificacion_45usuariomg56cLnzYggQs4zp8MRtRSmW8ufE7haj6VIN510sdXUMeta } from "/home/galadriel/az-agent/_work/1/s/pages/verificacion-usuario.vue?macro=true";
import { default as establecer_45contrasenaJ3V7PFjwbf6YE4CR9BSgK4RzavB9kQ_Y5zdRylDNYqUMeta } from "/home/galadriel/az-agent/_work/1/s/pages/establecer-contrasena.vue?macro=true";
import { default as gestion_45autenticacionhSsgarXwhkuBt2hz_dRqmO3KhsSvbrbxwpufXdb_458D4Meta } from "/home/galadriel/az-agent/_work/1/s/pages/gestion-autenticacion.vue?macro=true";
import { default as cxtierraqJwjbBGSSqBqeuAuj4LWG6kpFGziHdM6Lrly_456wWy54Meta } from "/home/galadriel/az-agent/_work/1/s/pages/herramientas/cxtierra.vue?macro=true";
import { default as indexswxETS4VcR_eHQ1UGqMn2jiOLXTm_45fGhTI_SM8dPra4Meta } from "/home/galadriel/az-agent/_work/1/s/pages/registro/cursos/index.vue?macro=true";
import { default as centros_45experimentalesXUs_45OPH_vq81t4XlQ8octWhmc98CdGQVq27d0QaFBxkMeta } from "/home/galadriel/az-agent/_work/1/s/pages/centros-experimentales.vue?macro=true";
import { default as indexUrmnW0QgrEP4_457pyu_8EUDoi2EE0azVrDH5_45aMQ3rWkMeta } from "/home/galadriel/az-agent/_work/1/s/pages/comunidad/[blog]/index.vue?macro=true";
import { default as indexrmm2I2Ju8qvdGwB2zwymfH1W0X2vd_45BWH1F_45KJ91X8wMeta } from "/home/galadriel/az-agent/_work/1/s/pages/formacion/cursos/index.vue?macro=true";
import { default as indexu5FiEs6_45iPbQa8j_45szQRIwTlDcPgkd8dpXllvBuBj_45MMeta } from "/home/galadriel/az-agent/_work/1/s/pages/registro/eventos/index.vue?macro=true";
import { default as _91id_93Qza_45Z00Zmjd_45QG3lT01BUAQH4X0KEMiFMXZ_x3TCueIMeta } from "/home/galadriel/az-agent/_work/1/s/pages/tierratv/playlist/[id].vue?macro=true";
import { default as _91slug_93wj67_ZMB7Qne_45x2aWOme6PzM2U001gEy0SwFxE7fSKAMeta } from "/home/galadriel/az-agent/_work/1/s/pages/comunidad/[blog]/[slug].vue?macro=true";
import { default as indexkDbMJDXcYTMGqewv4pbged_45nEFiAOe_HQGPxKDmSNnUMeta } from "/home/galadriel/az-agent/_work/1/s/pages/comunidad/autores/index.vue?macro=true";
import { default as _91slug_93GTlhFmaDKJK_45iBBz2Pcoef7oM9ZJ1egovVff_I9n39sMeta } from "/home/galadriel/az-agent/_work/1/s/pages/formacion/cursos/[slug].vue?macro=true";
import { default as _91slug_93Kp0LT4emD2hdZbfl9cCbGVwtQ7MfRyd31o3HIrZW7jAMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mercados/actualidad/[slug].vue?macro=true";
import { default as cuaderno_45de_45explotacion_45cxt1ZN_JitqsLvHgZAc_45qm7wgS5IwKWJ3nDaH6ickXDbAEMeta } from "/home/galadriel/az-agent/_work/1/s/pages/cuaderno-de-explotacion-cxt.vue?macro=true";
import { default as politica_45de_45cookies_45cxtierraZiLbf1rSr_45HscHrsDd9_FDPSvzV66K6OaaCbilSV9e0Meta } from "/home/galadriel/az-agent/_work/1/s/pages/politica-de-cookies-cxtierra.vue?macro=true";
import { default as index8RLEKe4dXN96M6Pm_91gPcb2dovHf6jqKU6lh3y7wpMMeta } from "/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/[convocatoria]/index.vue?macro=true";
import { default as inscripcionK9YxyQDF7FQGsYJD9XbDCsJKTgMUMCQDITt0ZgEpy6sMeta } from "/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/[convocatoria]/inscripcion.vue?macro=true";
import { default as _91slug_93xoGw3a_45dV3OpOIgZ_dUVMisgJiRkY_45zO0Bf0wj8_45po8Meta } from "/home/galadriel/az-agent/_work/1/s/pages/visita-nuestros-centros-experimentales/[slug].vue?macro=true";
import { default as _91subsector_93RrgyTJmzWobhOtFxkJLbCy1dMIGZ7_5TWU4LwY1hUNkMeta } from "/home/galadriel/az-agent/_work/1/s/pages/mercados/sector/[sector]/subsector/[subsector].vue?macro=true";
import { default as component_45stub9RAJFX2ozwLZXpIGqG31G8eyF5oJaw2zXR_45hhVc3tfsMeta } from "/home/galadriel/az-agent/_work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub9RAJFX2ozwLZXpIGqG31G8eyF5oJaw2zXR_45hhVc3tfs } from "/home/galadriel/az-agent/_work/1/s/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/index.vue")
  },
  {
    name: "perfil",
    path: "/perfil",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/perfil.vue")
  },
  {
    name: "guardados",
    path: "/guardados",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/guardados.vue")
  },
  {
    name: "mi-asesor",
    path: "/mi-asesor",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mi-asesor.vue")
  },
  {
    name: "mi-startup",
    path: "/mi-startup",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mi-startup.vue")
  },
  {
    name: "privacidad",
    path: "/privacidad",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/privacidad.vue")
  },
  {
    name: "aviso-legal",
    path: "/aviso-legal",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/aviso-legal.vue")
  },
  {
    name: "mis-eventos",
    path: "/mis-eventos",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mis-eventos.vue")
  },
  {
    name: "autor-slug",
    path: "/autor/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/autor/[slug].vue")
  },
  {
    name: "accesibilidad",
    path: "/accesibilidad",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/accesibilidad.vue")
  },
  {
    name: "invita-slug",
    path: "/invita/:slug()",
    meta: _91slug_93zPhop_7F4Esn5C2qPAwRUvxZwnnTWzoOGHag_UtSB7AMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/invita/[slug].vue")
  },
  {
    name: "publicaciones",
    path: "/publicaciones",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/publicaciones.vue")
  },
  {
    name: "quienes-somos",
    path: "/quienes-somos",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/quienes-somos.vue")
  },
  {
    name: "mercados",
    path: "/mercados",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mercados/index.vue")
  },
  {
    name: "registro",
    path: "/registro",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/registro/index.vue")
  },
  {
    name: "startups",
    path: "/startups",
    meta: indexL2q3ejcBBRZZlcjrjqg3uVKp96TCZttT9yDvnUL68HIMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/index.vue")
  },
  {
    name: "tierratv",
    path: "/tierratv",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/tierratv/index.vue")
  },
  {
    name: "comunidad",
    path: "/comunidad",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/comunidad/index.vue")
  },
  {
    name: "encuesta-slug",
    path: "/encuesta/:slug()",
    meta: _91slug_93_i2cL7rjy6ewhS7KwRJoFcGbCGaWf6IIYgPm9GqsDmYMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/encuesta/[slug].vue")
  },
  {
    name: "formacion",
    path: "/formacion",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/formacion/index.vue")
  },
  {
    name: "mercados-slug",
    path: "/mercados/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mercados/[slug].vue")
  },
  {
    name: "proyecto-slug",
    path: "/proyecto/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/proyecto/[slug].vue")
  },
  {
    name: "actualidad",
    path: "/actualidad",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/actualidad/index.vue")
  },
  {
    name: "formacion-slug",
    path: "/formacion/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/formacion/[slug].vue")
  },
  {
    name: "innovacion",
    path: "/innovacion",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/innovacion/index.vue")
  },
  {
    name: "actualidad-slug",
    path: "/actualidad/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/actualidad/[slug].vue")
  },
  {
    name: "innovacion-slug",
    path: "/innovacion/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/innovacion/[slug].vue")
  },
  {
    name: "actualizar-usuario",
    path: "/actualizar-usuario",
    meta: actualizar_45usuarioe2nzt_45rkwgMTX_SrnrMjquZ_Ofa37pWqvCowUX8yriQMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/actualizar-usuario.vue")
  },
  {
    name: "condiciones-de-uso",
    path: "/condiciones-de-uso",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/condiciones-de-uso.vue")
  },
  {
    name: "herramientas-slug",
    path: "/herramientas/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/herramientas/[slug].vue")
  },
  {
    name: "politica-de-cookies",
    path: "/politica-de-cookies",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/politica-de-cookies.vue")
  },
  {
    name: "resultados-busqueda",
    path: "/resultados-busqueda",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/resultados-busqueda.vue")
  },
  {
    name: "tierratv-video-id",
    path: "/tierratv/video/:id()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/tierratv/video/[id].vue")
  },
  {
    name: "verificacion-usuario",
    path: "/verificacion-usuario",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/verificacion-usuario.vue")
  },
  {
    name: "establecer-contrasena",
    path: "/establecer-contrasena",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/establecer-contrasena.vue")
  },
  {
    name: "gestion-autenticacion",
    path: "/gestion-autenticacion",
    meta: gestion_45autenticacionhSsgarXwhkuBt2hz_dRqmO3KhsSvbrbxwpufXdb_458D4Meta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/gestion-autenticacion.vue")
  },
  {
    name: "herramientas-cxtierra",
    path: "/herramientas/cxtierra",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/herramientas/cxtierra.vue")
  },
  {
    name: "registro-cursos",
    path: "/registro/cursos",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/registro/cursos/index.vue")
  },
  {
    name: "centros-experimentales",
    path: "/centros-experimentales",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/centros-experimentales.vue")
  },
  {
    name: "comunidad-blog",
    path: "/comunidad/:blog()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/comunidad/[blog]/index.vue")
  },
  {
    name: "formacion-cursos",
    path: "/formacion/cursos",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/formacion/cursos/index.vue")
  },
  {
    name: "registro-eventos",
    path: "/registro/eventos",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/registro/eventos/index.vue")
  },
  {
    name: "tierratv-playlist-id",
    path: "/tierratv/playlist/:id()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/tierratv/playlist/[id].vue")
  },
  {
    name: "comunidad-blog-slug",
    path: "/comunidad/:blog()/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/comunidad/[blog]/[slug].vue")
  },
  {
    name: "comunidad-autores",
    path: "/comunidad/autores",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/comunidad/autores/index.vue")
  },
  {
    name: "formacion-cursos-slug",
    path: "/formacion/cursos/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/formacion/cursos/[slug].vue")
  },
  {
    name: "mercados-actualidad-slug",
    path: "/mercados/actualidad/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mercados/actualidad/[slug].vue")
  },
  {
    name: "cuaderno-de-explotacion-cxt",
    path: "/cuaderno-de-explotacion-cxt",
    meta: cuaderno_45de_45explotacion_45cxt1ZN_JitqsLvHgZAc_45qm7wgS5IwKWJ3nDaH6ickXDbAEMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/cuaderno-de-explotacion-cxt.vue")
  },
  {
    name: "politica-de-cookies-cxtierra",
    path: "/politica-de-cookies-cxtierra",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/politica-de-cookies-cxtierra.vue")
  },
  {
    name: "startups-convocatoria",
    path: "/startups/:convocatoria()",
    meta: index8RLEKe4dXN96M6Pm_91gPcb2dovHf6jqKU6lh3y7wpMMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/[convocatoria]/index.vue")
  },
  {
    name: "startups-convocatoria-inscripcion",
    path: "/startups/:convocatoria()/inscripcion",
    meta: inscripcionK9YxyQDF7FQGsYJD9XbDCsJKTgMUMCQDITt0ZgEpy6sMeta || {},
    component: () => import("/home/galadriel/az-agent/_work/1/s/layers/startups/pages/startups/[convocatoria]/inscripcion.vue")
  },
  {
    name: "visita-nuestros-centros-experimentales-slug",
    path: "/visita-nuestros-centros-experimentales/:slug()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/visita-nuestros-centros-experimentales/[slug].vue")
  },
  {
    name: "mercados-sector-sector-subsector-subsector",
    path: "/mercados/sector/:sector()/subsector/:subsector()",
    component: () => import("/home/galadriel/az-agent/_work/1/s/pages/mercados/sector/[sector]/subsector/[subsector].vue")
  },
  {
    name: component_45stub9RAJFX2ozwLZXpIGqG31G8eyF5oJaw2zXR_45hhVc3tfsMeta?.name,
    path: "/formacion/las-ng-ts-como-herramienta-clave-para-un-agricultura-sostenible-en-la-union-europea",
    component: component_45stub9RAJFX2ozwLZXpIGqG31G8eyF5oJaw2zXR_45hhVc3tfs
  }
]